import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import MarkerAIcon from 'common/components/icons/MarkerAIcon';
import MarkerBIcon from 'common/components/icons/MarkerBIcon';
import {rideStatus} from 'common/types/Ride';
import RidePayment from 'common/components/RidePayment';

import styles from './RideList.css';


const iconStyle = {height: 18, width: 'auto', margin: '0 2px 2px', verticalAlign: 'middle'};
const listStyle = {paddingBottom: 72};
const naturalTimeStyle = {
  color: 'grey',
  display: 'block',
  marginTop: '6px',
  marginBottom: '5px',
  fontSize: '0.85em',
};
const statusStyleActive = {color: '#4a90e2', opacity: '12'};
const statusStyleInactive = {color: '#949494'};


const RideList = ({agencies, dataId, emptyMessage, rides, onClick}) => {
  if (rides.length === 0) {
    return <div className={styles.empty}>{emptyMessage}</div>;
  }

  return (
    <List data-id={dataId} style={listStyle}>
      {_.map(rides, (ride) => {
        const timezone = agencies[ride.agencyId].timezone;
        const rideTime = moment(ride.pickup.time || ride.createdAt || 0).tz(timezone);
        return (
          <div key={ride.rideId}>
            <div>
              <ListItem data-id={'ride-list-row'} onClick={() => onClick(ride)}>
                <ListItemText>
                  <div>
                    <span hidden data-id={'ride-row-id'}>{ride.rideId}</span>
                    <div className={styles.name}>
                      <div className={styles.rideTime}>
                        <span>{rideTime.format('MMM D, YYYY, h:mma')}</span>
                        {ride.isActive &&
                          <span style={naturalTimeStyle}>
                            ({moment.tz(timezone).to(rideTime)})
                          </span>
                        }
                      </div>
                      <div
                        data-id={'ride-row-status'}
                        className={styles.rideStatus}
                        style={ride.status === rideStatus.PENDING || rideStatus.IN_PROGRESS
                            ? statusStyleActive
                            : statusStyleInactive
                        }
                      >
                        {ride.readableRideStatus}
                      </div>
                    </div>
                    <div className={styles.details}>
                      <div className={styles.addresses}>
                        <div data-id={'ride-row-pickup-address'}>
                          <MarkerAIcon style={iconStyle} />
                          {ride.pickupName || ride.pickup.address}
                        </div>
                        <div data-id={'ride-row-dropoff-address'}>
                          <MarkerBIcon style={iconStyle} />
                          {ride.dropoffName || ride.dropoff.address}
                        </div>
                      </div>
                      { ride.fare !== null &&
                        <div data-id={'ride-row-fare'} className={styles.fare}>
                          <RidePayment
                            active={ride.isActive}
                            amount={ride.fare.cost.value}
                            currencyCode={ride.fare.cost.currency_code}
                            deeplinkService={ride.serviceTokenTransitUseDeeplink}
                            method={ride.fare.stripe_charge_id ? 'stripe' : 'vehicle'}
                            paid={ride.fare.paid}
                          />
                        </div>
                      }
                      <div className={styles.arrow}>
                        <KeyboardArrowRightIcon data-id={'ride-overview-button'} />
                      </div>
                    </div>
                  </div>
                </ListItemText>
              </ListItem>
            </div>
            <div className={styles.divider}><Divider /></div>
          </div>
        );
      })}
    </List>
  );
};

RideList.propTypes = {
  agencies: PropTypes.objectOf(PropTypes.object),
  dataId: PropTypes.string,
  emptyMessage: PropTypes.string,
  rides: PropTypes.array,
  onClick: PropTypes.func,
};

export default RideList;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideList/RideList.js